import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-form-input',
    templateUrl: './form-input.component.html',
    styleUrls: ['./form-input.component.scss'],
})
export class FormInputComponent implements OnInit {
    @Output() dataChanged: EventEmitter<string> = new EventEmitter();
    @Input() title: string;
    @Input() value: string;
    @Input() isLong = false;
    @Input() showSearch = false;
    formControl: FormControl;

    constructor() {}

    ngOnInit(): void {
        this.formControl = new FormControl(this.value);
        this.formControl.valueChanges.subscribe((value) => {
            return this.dataChanged.emit(value);
        });
    }

    nameField(): string {
        return this.title.replace(/\s/g, '');
    }
}
